import {
  ClassificationDocumentFinanceType,
  DocumentCreateType,
  ExpenseType,
  FinanceType,
  MerchantType,
  TransactionType,
} from "@/enums/enums";
import { ClassificationListModel } from "@/model/classification";
import { GetCreateTransactionPaymentDefualt } from "./paymentHelper";
import {
  GetCreateReferenceDepositSummaryDefualt,
  GetCreateTransactionCurrencySummaryDefualt,
  GetCreateTransactionItemDefualt,
  GetCreateTransactionItemForAI,
  GetCreateTransactionItemForAIChartOfAccount,
  GetCreateTransactionItemFromTransactionItem,
  GetCreateTransactionSummaryDefualt,
  SetCreateClassificationTransaction,
} from "./transactionHelper";

function GetContactDefaultForCreateTransaction() {
  return {
    id: 0,
    contactFullName: "",
    contactCode: "",
    contactTaxId: "",
    contactBranchCode: "",
    address: "",
    contactType: MerchantType.None,
    incomeDueDateTypeId: 0,
    incomeDueDateDay: 0,
    outflowDueDateTypeId: 0,
    outflowDueDateDay: 0,
    disabled: false,
    hidden: false,
    validateError: false,
  };
}

function GetModelQuotation(createOrEdit: DocumentCreateType) {
  const model = {
    id: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    headerName: "Quotation",
    transactionType: TransactionType.Quotation,
    financeType: FinanceType.InFlow,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Valid_Until",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      disabled: true,
      hidden: true,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: ([] as any[]) as any[],
    transactionItemDisabled: false,
    tagList: [] as any[],
    fileList: [] as any[],
    isValidateCreditLimit: true,
  };
  model.transactionItemList.push(GetCreateTransactionItemDefualt());
  return model;
}

function GetModelPurchaseOrder(createOrEdit: DocumentCreateType) {
  const model = {
    id: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    headerName: "Purchase_Order",
    transactionType: TransactionType.Quotation,
    financeType: FinanceType.OutFlow,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      disabled: true,
      hidden: true,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: ([] as any[]) as any[],
    transactionItemDisabled: false,
    tagList: [] as any[],
    fileList: [] as any[],
  };
  model.transactionItemList.push(GetCreateTransactionItemDefualt());
  return model;
}

function FilterClassificationByFinanceType(
  financeType: FinanceType,
  classificationList: Array<ClassificationListModel>
) {
  let _classificationList = new Array<ClassificationListModel>();

  if (classificationList && classificationList.length > 0) {
    if (financeType === FinanceType.InFlow) {
      _classificationList = classificationList.filter(
        (x) =>
          x.allocationDocumentFinanceType == ClassificationDocumentFinanceType.Income ||
          x.allocationDocumentFinanceType == ClassificationDocumentFinanceType.All
      );
    } else if (financeType === FinanceType.OutFlow) {
      _classificationList = classificationList.filter(
        (x) =>
          x.allocationDocumentFinanceType == ClassificationDocumentFinanceType.Expense ||
          x.allocationDocumentFinanceType == ClassificationDocumentFinanceType.All
      );
    }
  }

  return _classificationList;
}

function GetModelInvoice(createOrEdit: DocumentCreateType, classificationList: Array<ClassificationListModel>) {
  const model = {
    id: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    isNotSuggestionPayment: false,
    headerName: "Invoice",
    transactionType: TransactionType.Invoice,
    isValidateError: true,
    transactionDisabled: false,
    financeType: FinanceType.InFlow,
    expenseType: ExpenseType.None,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    remark: {
      text: "",
      validateError: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      disabled: false,
      hidden: false,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: ([] as any[]) as any[],
    transactionItemDisabled: false,
    payment: GetCreateTransactionPaymentDefualt(false),
    tagList: [] as any[],
    fileList: [] as any[],
    classificationTransactionList: SetCreateClassificationTransaction(classificationList),
    isValidateCreditLimit: true,
    referenceDepositList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(GetCreateTransactionItemDefualt());
  return model;
}

function GetModelExpense(createOrEdit: DocumentCreateType, classificationList: Array<ClassificationListModel>) {
  const model = {
    id: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    headerName: "Record_New_Expense",
    transactionType: TransactionType.Invoice,
    isValidateError: true,
    financeType: FinanceType.OutFlow,
    expenseType: ExpenseType.Expense,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Due_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      disabled: true,
      hidden: true,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: ([] as any[]) as any[],
    transactionItemDisabled: false,
    payment: GetCreateTransactionPaymentDefualt(),
    tagList: [] as any[],
    fileList: [] as any[],
    classificationTransactionList: SetCreateClassificationTransaction(classificationList),
    referenceDepositList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(GetCreateTransactionItemDefualt(ExpenseType.Expense));
  return model;
}

function GetModelPurchaseInventory(createOrEdit: DocumentCreateType) {
  const model = {
    id: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    headerName: "Purchase_Inventory_Record",
    transactionType: TransactionType.Invoice,
    isValidateError: true,
    financeType: FinanceType.OutFlow,
    expenseType: ExpenseType.PurchaseInventory,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Valid_Until",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      disabled: true,
      hidden: true,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: ([] as any[]) as any[],
    transactionItemDisabled: false,
    payment: GetCreateTransactionPaymentDefualt(),
    tagList: [] as any[],
    fileList: [] as any[],
  };
  model.transactionItemList.push(GetCreateTransactionItemDefualt(ExpenseType.PurchaseInventory));
  return model;
}

function GetModelPurchaseAsset(createOrEdit: DocumentCreateType) {
  const model = {
    id: 0,
    status: -2,
    documentType: createOrEdit,
    isNotAuto: false,
    headerName: "Invoice",
    transactionType: TransactionType.Invoice,
    isValidateError: true,
    financeType: FinanceType.OutFlow,
    expenseType: ExpenseType.PurchaseAsset,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Invoice number",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Invoice date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "Invoice duedate",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      disabled: false,
      hidden: false,
      value: false,
    },
    receivedTaxInvoice: {
      disabled: false,
      hidden: false,
      value: [],
      validateError: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [] as any[],
    transactionItemDisabled: false,
    payment: GetCreateTransactionPaymentDefualt(),
    tagList: [] as any[],
    fileList: [] as any[],
  };
  model.transactionItemList.push(GetCreateTransactionItemDefualt(ExpenseType.PurchaseAsset));
  return model;
}

function GetModelReceipt(createOrEdit: DocumentCreateType, classificationList: Array<ClassificationListModel>) {
  const model = {
    id: 0,
    status: -2,
    documentType: createOrEdit,
    isNotCalculateTransactionSummary: false,
    isNotAuto: false,
    isNotSuggestionPayment: false,
    headerName: "Receipt",
    transactionType: TransactionType.Receipt,
    financeType: FinanceType.InFlow,
    isValidateError: true,
    transactionDisabled: false,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      paymentGroupId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: false,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: false,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      disabled: false,
      hidden: false,
      value: false,
    },
    issueTaxDocument: {
      label: "issueTaxDocument",
      isNotAuto: false,
      disabled: false,
      hidden: false,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: GetCreateTransactionSummaryDefualt(),
    transactionCurrencySummary: GetCreateTransactionCurrencySummaryDefualt(),
    transactionItemList: [] as any[],
    transactionItemDisabled: false,
    payment: GetCreateTransactionPaymentDefualt(),
    tagList: [] as any[],
    fileList: [] as any[],
    isBillingNoteTransaction: false,
    billingNoteTransactionList: [],
    classificationTransactionList: SetCreateClassificationTransaction(classificationList),
    referenceDepositList: [],
    referenceDepositSummary: GetCreateReferenceDepositSummaryDefualt(),
  };
  model.transactionItemList.push(GetCreateTransactionItemDefualt());
  return model;
}

function GetModelTaxInvoiceDefualt(createOrEdit: DocumentCreateType) {
  const model = {
    id: 0,
    status: -2,
    documentType: createOrEdit,
    isNotCalculateTransactionSummary: true,
    isNotAuto: false,
    headerName: "Menu_SalesTaxInvoice",
    transactionType: TransactionType.TaxInvoice,
    financeType: FinanceType.InFlow,
    isValidateError: true,
    transactionDisabled: true,
    reference: {
      label: "Refer_to",
      placeholder: "Refer_to_placeholder",
      disabled: false,
      hidden: false,
      referenceName: "",
      referenceId: 0,
      referenceTypeId: 0,
      validateError: false,
    },
    transactionDiscount: {
      value: "0.00",
      discountType: 0,
      isActive: false,
      disabled: true,
      isHidden: false,
      validateError: false,
    },
    number: {
      label: "Document_No",
      placeholder: "Document_No_placeholder",
      disabled: false,
      hidden: false,
      value: "",
      validateError: false,
    },
    date: {
      label: "Issue_Date",
      disabled: false,
      hidden: false,
      value: new Date().ToDateJsonString(),
      validateError: false,
    },
    dueDate: {
      label: "",
      disabled: true,
      hidden: true,
      value: new Date().ToDateJsonString(),
      validateError: false,
      isNotAuto: false,
    },
    remark: {
      text: "",
      validateError: false,
    },
    contact: GetContactDefaultForCreateTransaction(),
    taxStatus: {
      label: "taxStatus",
      disabled: true,
      hidden: false,
      value: 0,
      isNotAuto: false,
    },
    issueTaxInvoice: {
      label: "issueTaxInvoice",
      disabled: true,
      hidden: true,
      value: false,
    },
    transactionItemListLabel: "Item",
    transactionSummaryLabel: "Summary_InFormation",
    transactionSummary: GetCreateTransactionSummaryDefualt(true),
    transactionCurrencySummary: GetCreateTransactionCurrencySummaryDefualt(true),
    transactionItemList: [] as any[],
    transactionItemDisabled: true,
    tagList: [] as any[],
    fileList: [] as any[],
    isBillingNoteTransaction: false,
    billingNoteTransactionList: [],
  };
  model.transactionItemList.push(GetCreateTransactionItemDefualt());
  return model;
}

function GetModelCreditNote(createOrEdit: DocumentCreateType, financeType: FinanceType, expenseType: ExpenseType) {
  let model = {};
  if (createOrEdit == DocumentCreateType.Create) {
    model = {
      header: {
        docmentType: "สร้าง",
        headerName: "ใบลดหนี้",

        isValidateError: true,

        inputRefNumber: {
          label: "อ้างอิงเอกสาร",
          disabled: true,
          showElement: true,
          value: "",
        },
        inputDocNumber: {
          label: "เอกสารเลขที่",
          disabled: false,
          showElement: true,
          value: "",
        },
        listContact: {
          disabled: true,
          showElement: true,
          value: "",
        },
        calendar: {
          labelStart: "วันที่ออก",
          labelEnd: "",
          disabled: false,
          showElement: true,
          value: "",
          syncData: true,
        },
        pricingAndTaxInformation: false,
        inputSetPrice: {
          disabled: false,
          showElement: true,
          value: "",
        },
        switchTaxInvoice: {
          disabled: false,
          showElement: true,
          value: "",
        },
        listCurrency: {
          disabled: false,
          showElement: true,
          value: "",
        },
        inputExchangeRate: {
          disabled: false,
          showElement: true,
          value: "",
        },
      },
    };
  }

  return model;
}

function GetModelReceivedCreditNote(
  createOrEdit: DocumentCreateType,
  financeType: FinanceType,
  expenseType: ExpenseType
) {
  let model = {};
  if (createOrEdit == DocumentCreateType.Create) {
    model = {
      header: {
        docmentType: "รับ",
        headerName: "ใบลดหนี้",
        isValidateError: true,
        inputRefNumber: {
          label: "อ้างอิงถึง",
          disabled: true,
          showElement: true,
          value: "",
        },
        inputDocNumber: {
          label: "เอกสารเลขที่",
          disabled: false,
          showElement: true,
          value: "",
        },
        listContact: {
          disabled: true,
          showElement: true,
          value: "",
        },
        calendar: {
          labelStart: "วันที่ออก",
          labelEnd: "",
          disabled: false,
          showElement: true,
          value: "",
          syncData: true,
        },
        pricingAndTaxInformation: false,
        inputSetPrice: {
          disabled: false,
          showElement: true,
          value: "",
        },
        switchTaxInvoice: {
          disabled: false,
          showElement: true,
          value: "",
        },
        listCurrency: {
          disabled: false,
          showElement: true,
          value: "",
        },
        inputExchangeRate: {
          disabled: false,
          showElement: true,
          value: "",
        },
      },
    };
  }

  return model;
}

function GetModelBillingNote(
  createOrEdit: DocumentCreateType,

  financeType: FinanceType,
  expenseType: ExpenseType
) {
  let model = {};
  if (createOrEdit == DocumentCreateType.Create) {
    model = {
      header: {
        docmentType: "สร้าง",
        headerName: "ใบวางบิล",

        isValidateError: true,

        inputRefNumber: {
          label: "อ้างอิงถึง",
          disabled: false,
          showElement: false,
        },
        inputDocNumber: {
          label: "เอกสารเลขที่",
          disabled: false,
          showElement: true,
          value: "",
        },
        listContact: {
          disabled: true,
          showElement: true,
          value: "",
        },
        calendar: {
          labelStart: "วันที่ออก",
          labelEnd: "วันที่ครบกำหนด",
          disabled: false,
          showElement: true,
          value: "",
          syncData: true,
        },
        pricingAndTaxInformation: false,
        inputSetPrice: {
          disabled: false,
          showElement: true,
          value: "",
        },
        switchTaxInvoice: {
          disabled: false,
          showElement: true,
          value: "",
        },
        listCurrency: {
          disabled: false,
          showElement: true,
          value: "",
        },
        inputExchangeRate: {
          disabled: false,
          showElement: true,
          value: "",
        },
      },
    };
  }

  return model;
}

function GetModelCombinePaymentNote(
  createOrEdit: DocumentCreateType,

  financeType: FinanceType,
  expenseType: ExpenseType
) {
  let model = {};
  if (createOrEdit == DocumentCreateType.Create) {
    model = {
      header: {
        docmentType: "",
        headerName: "ใบรวมจ่าย",
        isValidateError: true,
        inputRefNumber: {
          label: "เลขที่ใบวางบิลที่รับมา",
          disabled: false,
          showElement: true,
          value: "",
        },
        inputDocNumber: {
          label: "เลขที่บันทึกใบรวมจ่าย",
          disabled: false,
          showElement: true,
          value: "",
        },
        listContact: {
          disabled: true,
          showElement: true,
          value: "",
        },
        calendar: {
          labelStart: "วันที่ออก",
          labelEnd: "วันที่ครบกำหนด",
          disabled: false,
          showElement: true,
          value: "",
          syncData: true,
        },
        pricingAndTaxInformation: false,
        inputSetPrice: {
          disabled: false,
          showElement: true,
          value: "",
        },
        switchTaxInvoice: {
          disabled: false,
          showElement: true,
          value: "",
        },
        listCurrency: {
          disabled: false,
          showElement: true,
          value: "",
        },
        inputExchangeRate: {
          disabled: false,
          showElement: true,
          value: "",
        },
      },
    };
  }

  return model;
}

export function CreateModel(
  createOrEdit: DocumentCreateType,
  transactionType: TransactionType,
  financeType: FinanceType,
  expenseType: ExpenseType,
  classificationList: Array<ClassificationListModel> = new Array<ClassificationListModel>()
) {
  switch (transactionType) {
    case TransactionType.Quotation:
      if (financeType == FinanceType.InFlow) {
        return GetModelQuotation(createOrEdit);
      } else {
        return GetModelPurchaseOrder(createOrEdit);
      }
      break;
    case TransactionType.Invoice:
      if (financeType == FinanceType.InFlow) {
        return GetModelInvoice(createOrEdit, FilterClassificationByFinanceType(FinanceType.InFlow, classificationList));
      } else {
        if (expenseType == ExpenseType.Expense) {
          return GetModelExpense(
            createOrEdit,
            FilterClassificationByFinanceType(FinanceType.OutFlow, classificationList)
          );
        } else if (expenseType == ExpenseType.PurchaseInventory) {
          return GetModelPurchaseInventory(createOrEdit);
        } else if (expenseType == ExpenseType.PurchaseAsset) {
          return GetModelPurchaseAsset(createOrEdit);
        }
      }
      break;
    case TransactionType.Receipt:
      return GetModelReceipt(createOrEdit, FilterClassificationByFinanceType(FinanceType.InFlow, classificationList));
      break;
    case TransactionType.TaxInvoice:
      return GetModelTaxInvoiceDefualt(createOrEdit);
      break;
    case TransactionType.CreditNote:
      if (financeType == FinanceType.InFlow) {
        return GetModelCreditNote(createOrEdit, financeType, expenseType);
      } else {
        return GetModelReceivedCreditNote(createOrEdit, financeType, expenseType);
      }

      break;
    case TransactionType.BillingNote:
      if (financeType == FinanceType.InFlow) {
        return GetModelBillingNote(createOrEdit, financeType, expenseType);
      } else {
        return GetModelCombinePaymentNote(createOrEdit, financeType, expenseType);
      }
      break;
  }
}

export function SetAIInvoice(transaction: any, transactionDetail: any) {
  transaction.id = transactionDetail.id.ToNumber();
  transaction.contact.id = transactionDetail.contactId;
  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (const transactionDetailItem of transactionDetail.transactionItems) {
      transaction.transactionItemList.push(
        GetCreateTransactionItemForAI(transactionDetailItem, transactionDetail.expenseType)
      );
    }
  }
}

export function SetAIChartOfAccount(transaction: any, contactId: any, aiSuggestionTransaction: any, expenseType: any) {
  transaction.contact.id = contactId;
  if (aiSuggestionTransaction.chartOfAccountList && aiSuggestionTransaction.chartOfAccountList.length > 0) {
    transaction.transactionItemList = [];
    for (const chartOfAccount of aiSuggestionTransaction.chartOfAccountList) {
      if (chartOfAccount.accountId > 0) {
        transaction.transactionItemList.push(
          GetCreateTransactionItemForAIChartOfAccount(chartOfAccount.accountId, expenseType)
        );
      }
    }
  }
}

export function SetCopyInvoiceModel(transaction: any, transactionDetail: any) {
  transaction.id = transactionDetail.id.ToNumber();
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (const transactionDetailItem of transactionDetail.transactionItems) {
      transaction.transactionItemList.push(
        GetCreateTransactionItemFromTransactionItem(transactionDetailItem, true, transactionDetail.expenseType)
      );
    }
  }
  transaction.isNotAuto = true;
  transaction.issueTaxInvoice.value = transactionDetail.isCreatedTaxInvoice;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate = transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt = transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal = transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt = transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal = transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit = transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
}

export function SetBookmarkForTransaction(transaction: any, transactionDetail: any) {
  transaction.id = transactionDetail.transactionTemplateId.ToNumber();
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;

  if (transactionDetail.transactionItems && transactionDetail.transactionItems.length > 0) {
    transaction.transactionItemList = [];
    for (const transactionDetailItem of transactionDetail.transactionItems) {
      transaction.transactionItemList.push(
        GetCreateTransactionItemFromTransactionItem(transactionDetailItem, true, transactionDetail.expenseType)
      );
    }
  }

  transaction.isNotAuto = true;
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate = transactionDetail.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.currencyRatio;
  transaction.transactionSummary.vat.preVatTotalDefualt = transactionDetail.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.preVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt = transactionDetail.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal = transactionDetail.currencyPreVatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.vatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt = transactionDetail.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal = transactionDetail.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit = transactionDetail.currencyVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.sameProductVatTypeId;
}
